import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser';
import { msalConfig, isAuthBypassed } from './config';

/**
 * MSAL instance - singleton for the entire application
 */
export const msalInstance = isAuthBypassed
  ? ({} as PublicClientApplication) // Mock instance when auth is bypassed
  : new PublicClientApplication(msalConfig);

// Only initialize MSAL if auth is not bypassed
if (!isAuthBypassed) {
  // Account selection logic
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Listen for sign-in events
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  // Handle redirect promise on page load
  msalInstance.initialize().then(() => {
    msalInstance
      .handleRedirectPromise()
      .then(response => {
        if (response && response.account) {
          msalInstance.setActiveAccount(response.account);
        }
      })
      .catch(error => {
        console.error('Failed to handle redirect:', error);
      });
  });
}
